<template>
	<div id="pics">
		<div style="height: 100vh;"  v-if="this.cid!==4?true:false">
			<!-- swiper1 -->
			<swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
				<swiper-slide v-for="(item,key) in list" :key="key">
					<center><img style="margin-top: 200px;" :src="item.works_images[0].image_url" width="500" height="auto" /></center>
				</swiper-slide>

				<div class="swiper-button-next swiper-button-white" slot="button-next"></div>
				<div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
			</swiper>
			<!-- swiper2 Thumbs -->
			<swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
				<swiper-slide v-for="(item,key) in list" :key="key">
					<center><img :src="item.works_images[0].image_url" width="50" height="auto" /></center>
				</swiper-slide>

			</swiper>
		</div>
		<div style="height: 100vh;" v-if="this.cid===4?true:false">
			<!-- swiper1 -->
			<swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
				<swiper-slide v-for="(item,key) in list.perf_picture" :key="key">
					<center><img style="margin-top: 200px;" :src="item.image_url" width="500" height="auto" /></center>
				</swiper-slide>

				<div class="swiper-button-next swiper-button-white" slot="button-next"></div>
				<div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
			</swiper>
			<!-- swiper2 Thumbs -->
			<swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
				<swiper-slide v-for="(item,key) in list.perf_picture" :key="key">
					<center><img :src="item.image_url" width="50" height="auto" /></center>
				</swiper-slide>

			</swiper>
		</div>
	</div>
</template>

<script>
	import storage from '../storage/storage.js'
	export default {
		data() {
			return {
				list: '',
				aid: '', //用户id
				cid: '', //类别id
				// isshow: false,
				swiperOptionTop: {
					// spaceBetween: 10,
					// loop:true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},
				swiperOptionThumbs: {
					// spaceBetween: 10,
					centeredSlides: true,
					slidesPerView: 'auto',
					touchRatio: 0.2,
					slideToClickedSlide: true
				}
			}
		},
		methods: {
			getpics() {
				if (this.cid == '4') { //判断传值过来的参数，作为类别判断，为4则是艺人展示
					var api = 'https://api.yopoo.cn/api/v1/actor?id=' + this.aid;
					this.$http.get(api).then((res) => {
						console.log(res)
						this.list = res.body

					})
				} 
				if(this.cid != '4'){	//cid不为4则是作品图集
					var api = "https://api.yopoo.cn/api/v1/picturemerge?artistId=" + this.aid + "&category=" + this.cid
					this.$http.get(api).then((res) => {
						console.log(res)
						this.list = res.body

					})
				}
			}

		},
		
		mounted() {
			this.aid = storage.get('aid')
			this.cid = storage.get('cid')
			this.getpics()
			this.$nextTick(() => {
				const swiperTop = this.$refs.swiperTop.swiper
				const swiperThumbs = this.$refs.swiperThumbs.swiper
				swiperTop.controller.control = swiperThumbs
				swiperThumbs.controller.control = swiperTop
			})


		}
	}
</script>

<style lang="scss" scoped>
	.swiper-container {
		background-color: #000;
	}



	.gallery-top {
		height: 80% !important;
		width: 100%;
	}

	.gallery-thumbs {
		height: 20% !important;
		box-sizing: border-box;
		padding: 10px 0;
	}

	.gallery-thumbs .swiper-slide {
		width: 12%;
		height: 100%;
		opacity: 0.4;
	}

	.gallery-thumbs .swiper-slide-active {
		opacity: 1;
	}
</style>



// WEBPACK FOOTER //
// src/components/Pics.vue